'use client';

import { type RefObject, useEffect, useState } from 'react';

/**
 * Whether the element has scrolled up under the sticky bar `barSelector` names:
 * its bottom edge sits at or above the bar's. Compares live edges, so a bar
 * that changes height while scrolling needs no re-measuring. Starts `false`,
 * which is also the server's answer.
 */
export function useScrolledUnder(ref: RefObject<Element | null>, barSelector: string) {
    const [isUnder, setIsUnder] = useState(false);

    useEffect(() => {
        const element = ref.current;
        const bar = document.querySelector(barSelector);

        if (!element || !bar) return;

        const update = () => {
            setIsUnder(element.getBoundingClientRect().bottom <= bar.getBoundingClientRect().bottom);
        };

        update();
        window.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);

        return () => {
            window.removeEventListener('scroll', update);
            window.removeEventListener('resize', update);
        };
    }, [ref, barSelector]);

    return isUnder;
}
